module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/230-singapore-a1dfbef515fa7029a2056da9a7aa02ef.svg";